import { render, staticRenderFns } from "./batchImport.vue?vue&type=template&id=aa5d23be&scoped=true&"
import script from "./batchImport.vue?vue&type=script&lang=js&"
export * from "./batchImport.vue?vue&type=script&lang=js&"
import style0 from "./batchImport.vue?vue&type=style&index=0&id=aa5d23be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa5d23be",
  null
  
)

export default component.exports